var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from 'prop-types';
import { NACKLE_PAPER_PREFIX as NKL } from "../../namespaceHack";
/**
 * Demonstrates how example Javascript components can be added to Nackle Paper
 */
var ExampleCustomJs = /** @class */ (function (_super) {
    __extends(ExampleCustomJs, _super);
    function ExampleCustomJs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExampleCustomJs.prototype.render = function () {
        return (React.createElement("div", { className: NKL + "-example-custom-js" },
            "value = ",
            this.props.value));
    };
    ExampleCustomJs.propTypes = {
        value: PropTypes.string.isRequired,
    };
    return ExampleCustomJs;
}(Component));
export { ExampleCustomJs };
//# sourceMappingURL=index.js.map